import { Injectable } from '@angular/core';

import { DefaultHttpUrlGenerator, HttpResourceUrls, normalizeRoot, Pluralizer } from '@ngrx/data';
import { EntityResourceUrls } from './entityResourceUrls';
import { defaultDataServiceConfig } from '../defaultDataServiceConfig';

@Injectable({ providedIn: 'root' })
export class CustomizeHttpUrlGenerator extends DefaultHttpUrlGenerator {

    constructor(private plural: Pluralizer) {
        super(plural);
    }

    getEntityResourceUrl(entityName: string) {
        const root = defaultDataServiceConfig.root;
        const httpResourceUrls = this.getResourceUrls(entityName, root);
        return httpResourceUrls.entityResourceUrl;
    }

    getEntityCollectionResourceUrl(entityName: string) {
        const root = defaultDataServiceConfig.root;
        const httpResourceUrls = this.getResourceUrls(entityName, root);
        return httpResourceUrls.collectionResourceUrl;
    }

    protected getResourceUrls(
        entityName: string,
        root: string
    ): HttpResourceUrls {
        // // console.logByType'NN entity name' + entityName);
        // // console.logByType['urls', urls]);
        // // console.logByType['custom urls', urls, entityName]);
        let resourceUrls = this.knownHttpResourceUrls[entityName];
        if (!resourceUrls) {
            const nRoot = normalizeRoot(root);
            const formattedEntityName = this.resolveEntityName(entityName);

            // // console.logByType['custom urls', urls]);
            /*  console.log(['custom urls', urls, entityName]);
             urls.forEach(value => {
                 console.log(value);
                 console.log([value, value.entityName]);
             }); */
            const customUrls = urls.find(value => value.entityName === entityName);
            // // console.logByType['custom urls for entity' + entityName, customUrls]);
            const entityResourceUrl = customUrls ? `${nRoot}/${customUrls.entityResourceUrl}/` : `${nRoot}/${formattedEntityName}/`;
            const collectionResourceUrl = customUrls ? `${nRoot}/${customUrls.collectionResourceUrl}/` : `${nRoot}/${this.plural.pluralize(formattedEntityName)}/`;

            resourceUrls = {
                entityResourceUrl,
                collectionResourceUrl,
            };
            this.registerHttpResourceUrls({ [entityName]: resourceUrls });
        }
        // console.dir(resourceUrls);
        return resourceUrls;
    }

    private resolveEntityName(entityName: string): string {
        //// console.logByType'entityName: ' +entityName);
        return entityName.charAt(0).toLowerCase() + entityName.slice(1);
    }
}

// FIXME explode this into modules
const urls: EntityResourceUrls[] = [

    // Common
    new EntityResourceUrls('AudioRecord', 'audio/record', 'audio/records')
    , new EntityResourceUrls('AudioTranscription', 'core/audio-transcription', 'core/audio-transcriptions')

    , new EntityResourceUrls('BusinessDataImportProcess', 'common/business-data-import/process', 'common/business-data-import/processes')
    , new EntityResourceUrls('GoalDefinition', 'goal/definition', 'goal/definitions')
    , new EntityResourceUrls('Goal', 'goal/goal', 'goal/goals')
    , new EntityResourceUrls('NotificationDefinition', 'notification/definition', 'notification/definitions')
    , new EntityResourceUrls('NotificationDefinitionGroup', 'notification/definition/group', 'notification/definition/groups')
    , new EntityResourceUrls('NotificationSetting', 'notification/setting', 'notification/settings')
    , new EntityResourceUrls('Notification', 'notification/notification', 'notification/notifications')
    , new EntityResourceUrls('Note', 'partnerNote', 'partnerNotes')
    , new EntityResourceUrls('Tag', 'core/tag', 'core/tags')
    , new EntityResourceUrls('DocumentTemplate', 'document-template', 'document-templates')
    // Medical
    , new EntityResourceUrls('MedicalRecordGeneralInformation', 'medicalRecord/generalInformation', 'medicalRecord/generalInformations')
    , new EntityResourceUrls('MedicalPractitioner', 'medical/practitioner', 'medical/practitioners')
    , new EntityResourceUrls('MedicalSport', 'medical/sport', 'medical/sports')
    , new EntityResourceUrls('MedicalPain', 'medical/pain', 'medical/pains')
    , new EntityResourceUrls('MedicalRecordVisitReason', 'medical/visit-reason', 'medical/visit-reasons')
    , new EntityResourceUrls('MedicalProblem', 'medical/problem', 'medical/problems')
    , new EntityResourceUrls('ChargedAct', 'medical/charged-act', 'medical/charged-acts')
    , new EntityResourceUrls('MedicalReport', 'medical/report', 'medical/reports')
    , new EntityResourceUrls('TreatmentDefinition', 'medical/treatment/form-definition', 'medical/treatment/form-definitions')
    , new EntityResourceUrls('Treatment', 'medical/treatment', 'medical/treatments')
    , new EntityResourceUrls('TreatmentFeedback', 'medical/treatment/feedback', 'medical/treatment/feedbacks')
    , new EntityResourceUrls('TreatmentJourneyDefinition', 'medical/treatment/journey/definition', 'medical/treatment/journey/definitions')
    , new EntityResourceUrls('TreatmentJourney', 'medical/treatment/journey', 'medical/treatment/journeys')
    , new EntityResourceUrls('PrescriptionMedicine', 'medical/prescription/medicine', 'medical/prescription/medicines')
    , new EntityResourceUrls('Prescription', 'medical/prescription/prescription', 'medical/prescription/prescriptions')
    , new EntityResourceUrls('PrescriptionDefinition', 'medical/prescription/prescription-model', 'medical/prescription/prescription-models')
    , new EntityResourceUrls('Consultation', 'medical/consultation', 'medical/consultations')
    , new EntityResourceUrls('ConsultationCategory', 'medical/consultation/category', 'medical/consultation/categories')
    , new EntityResourceUrls('MedicalMorphology', 'medical/morphology', 'medical/morphologies')
    , new EntityResourceUrls('Diagnostic', 'medical/diagnostic', 'medical/diagnostics')
    , new EntityResourceUrls('DiagnosticRuleGroup', 'medical/diagnostic/rule-group', 'medical/diagnostic/rule-groups')
    , new EntityResourceUrls('MedicalDeviceDefinition', 'medical/device/definition', 'medical/device/definitions')
    , new EntityResourceUrls('MedicalDevice', 'medical/device/account-device', 'medical/device/account-devices')
    , new EntityResourceUrls('MedicalSterilization', 'medical/sterilization', 'medical/sterilizations')
    , new EntityResourceUrls('MedicalToolSet', 'medical/instrument-set', 'medical/instrument-sets')
    // AI
    , new EntityResourceUrls('AiDiscussion', 'ai/discussion', 'ai/discussions')

    // Agenda
    , new EntityResourceUrls('AgendaCategory', 'agenda/category', 'agenda/categories')
    , new EntityResourceUrls('AgendaCalendar', 'agenda/calendar', 'agenda/calendars')
    , new EntityResourceUrls('AgendaEvent', 'agenda/event', 'agenda/events')
    , new EntityResourceUrls('AgendaPeriod', 'agenda/period', 'agenda/periods')
    , new EntityResourceUrls('AgendaSlot', 'agenda/slot', 'agenda/slots')
    , new EntityResourceUrls('AgendaReminderConfiguration', 'agenda/reminder/configuration', 'agenda/reminder/configurations')
    , new EntityResourceUrls('AgendaBlockedPartner', 'agenda/blocked-person', 'agenda/blocked-persons')
    , new EntityResourceUrls('AgendaWaitingList', 'agenda/waiting-list/item', 'agenda/waiting-list/items')
    , new EntityResourceUrls('AgendaProfile', 'agenda/online-profile', 'agenda/online-profiles')
    // Communication
    , new EntityResourceUrls('EmailMailbox', 'communication/email/mailbox', 'communication/email/mailboxs')
    , new EntityResourceUrls('CommunicationContentModel', 'communication/content-model', 'communication/content-models')
    , new EntityResourceUrls('CommunicationContentSubstitution',
        'communication/content-substitution', 'communication/content-substitutions')
    , new EntityResourceUrls('CommunicationReport',
        'communication/report', 'communication/reports')
    , new EntityResourceUrls('CommunicationConfigurationEmailSender', 'communication/configuration/email/sender', 'communication/configuration/email/senders')
    , new EntityResourceUrls('VisualIdentity', 'communication/visual-identity', 'communication/viual-identities')
    , new EntityResourceUrls('EmailTheme', 'communication/email-theme', 'communication/email-themes')
    , new EntityResourceUrls('EmailThemeDefinition', 'communication/email-theme-definition', 'communication/email-theme-definitions')
    , new EntityResourceUrls('ReportTheme', 'communication/report-theme', 'communication/report-themes')
    , new EntityResourceUrls('ReportThemeDefinition', 'communication/report-theme-definition', 'communication/report-theme-definitions')
    , new EntityResourceUrls('WebsiteTheme', 'communication/website-theme', 'communication/website-themes')

    // Insole
    , new EntityResourceUrls('Insoles', 'insole/insole', 'insole/insoles')
    , new EntityResourceUrls('InsolesModel', 'insole/insoles-model', 'insole/insoles-models')
    , new EntityResourceUrls('InsoleMaterial', 'insole/insole-material', 'insole/insole-materials')

    , new EntityResourceUrls('InsolesProfile', 'insole/profile', 'insole/profiles')
    , new EntityResourceUrls('Scanner3d', 'insole/scanner3d', 'insole/scanner3ds')
    , new EntityResourceUrls('Scanner3dAccount', 'insole/scanner3d-account', 'insole/scanner3d-accounts')
    , new EntityResourceUrls('Scan3dGroup', 'insole/scan3d-group', 'insole/scan3d-groups')
    , new EntityResourceUrls('Scan3d', 'insole/scan3d', 'insole/scan3ds')
    , new EntityResourceUrls('InsoleElementDefinition', 'insole/insole-element/definition', 'insole/insole-element/definitions')
    , new EntityResourceUrls('InsolesProviderModel', 'insole/provider-model', 'insole/provider-models')
    , new EntityResourceUrls('InsoleCadProcess', 'insole/cad-process', 'insole/cad-processes')
    , new EntityResourceUrls('ProviderCamMachine', 'insole/provider/cam-machine', 'insole/provider/cam-machines')

    // Cam
    , new EntityResourceUrls('CamJob', 'cam/job', 'cam/jobs')


    // forms
    , new EntityResourceUrls('ExamenDefinition', 'exam/form-definition', 'exam/form-definitions')
    , new EntityResourceUrls('ExamForm', 'exam-form', 'exam-forms')
    , new EntityResourceUrls('FormDefinitionForm', 'form-definition/form', 'form-definition/forms')
    , new EntityResourceUrls('FormDefinitionField', 'form-definition/field', 'form-definition/fields')
    , new EntityResourceUrls('OnlineFormFormDefinition', 'online-form/definition', 'online-form/definitions')
    , new EntityResourceUrls('OnlineFormForm', 'online-form/form', 'online-form/forms')
    , new EntityResourceUrls('OnlineAgendaCalendarAvailability', 'online-agenda/calendar/availability', 'online-agenda/calendar/availabilities')

    // Newsletter
    , new EntityResourceUrls('NewsletterPartnerConfig', 'newsletter/partner-config', 'newsletter/partner-config')

    // Office
    , new EntityResourceUrls('Office', 'office', 'offices')

    // Parcel
    , new EntityResourceUrls('Parcel', 'parcel/parcel', 'parcel/parcels')

    // Partners
    , new EntityResourceUrls('PartnerPerson', 'partner-person', 'partner-persons')
    , new EntityResourceUrls('PartnerContact', 'partner-contact', 'partner-contacts')

    // Reporting
    , new EntityResourceUrls('ReportComponentDefinition', 'reporting/report-component-definition', 'reporting/report-component-definitions')
    , new EntityResourceUrls('ReportComponent', 'reporting/report-component', 'reporting/report-components')
    , new EntityResourceUrls('ReportAccountComponent', 'reporting/account-report-component', 'reporting/account-report-components')
    , new EntityResourceUrls('ReportDefinition', 'reporting/report-definition', 'reporting/report-definitions')


    // Sale
    , new EntityResourceUrls('Sale', 'sale/sale', 'sale/sales')
    , new EntityResourceUrls('SaleInvoice', 'sale/invoice', 'sale/invoices')
    , new EntityResourceUrls('SaleInvoiceConfiguration', 'sale/invoice/configuration', 'sale/invoice/configurations')
    , new EntityResourceUrls('SaleProduct', 'sale/sale-product', 'sale/sale-products')
    , new EntityResourceUrls('SaleRetrocession', 'sale/retrocession', 'sale/retrocessions')

    // Payment request
    , new EntityResourceUrls('PaymentRequest', 'sale/paymentRequest', 'sale/paymentRequests')
    , new EntityResourceUrls('PaymentRequestConfiguration', 'sale/paymentRequest/configuration', 'sale/paymentRequest/configurations')
    , new EntityResourceUrls('PaymentRequestReminder', 'sale/paymentRequest/reminder', 'sale/paymentRequest/reminders')
    , new EntityResourceUrls('PaymentRequestMovement', 'sale/paymentRequest/movement', 'sale/paymentRequest/movements')
    , new EntityResourceUrls('PaymentRequestOnlineAttempt', 'sale/paymentRequest/onlineAttempt', 'sale/paymentRequest/onlineAttempts')
    // Payment
    , new EntityResourceUrls('PaymentCardReader', 'payment/card-reader', 'payment/card-readers')

    // Product
    , new EntityResourceUrls('ProductDelivered', 'product/delivered-product', 'product/delivered-products')
    , new EntityResourceUrls('Product', 'product', 'products')
    , new EntityResourceUrls('ProductRetrocession', 'product/retrocession', 'product/retrocessions')
    , new EntityResourceUrls('PurchaseOrder', 'sale/purchase-order', 'sale/purchase-orders')
    , new EntityResourceUrls('ProductStockUnit', 'product/stock/unit', 'product/stock/units')
    // Subscription
    , new EntityResourceUrls('Subscription', 'subscription', 'subscriptions')
    , new EntityResourceUrls('ProviderService', 'provider-service', 'provider-services')
    , new EntityResourceUrls('ProviderServiceOption', 'provider/service/option', 'provider/service/options')
    , new EntityResourceUrls('PriceList', 'price-list', 'price-lists')

    // Support
    , new EntityResourceUrls('Support', 'support', 'supports')

    // Workflow
    , new EntityResourceUrls('WorkflowTask', 'workflow/task', 'workflow/tasks')
    , new EntityResourceUrls('WorkflowTaskDefinition', 'workflow/task-definition', 'workflow/task-definitions')

    // Discussion
    , new EntityResourceUrls('Message', 'message', 'messages')
    , new EntityResourceUrls('Discussion', 'discussion', 'discussions')
    , new EntityResourceUrls('DiscussionMessage', 'discussion/message', 'discussion/messages')

    // Webshop
    , new EntityResourceUrls('WebshopProduct', 'webshop/product', 'webshop/products')
    , new EntityResourceUrls('WebshopCategory', 'webshop/category', 'webshop/categories')
    , new EntityResourceUrls('WebshopCart', 'webshop/cart', 'webshop/carts')

    // Metrics
    , new EntityResourceUrls('PageViewed', 'metrics/page-viewed', 'metrics/pages-viewed')

    // Accounting
    , new  EntityResourceUrls('BankCheck', 'accounting/bank-check', 'accounting/bank-checks')
    , new  EntityResourceUrls('AccountingAccount', 'accounting/account', 'accounting/accounts')
    , new EntityResourceUrls('AccountingMovement', 'accounting/movement', 'accounting/movements')
    , new EntityResourceUrls('AccountingOpenBankingRequisition', 'accounting/openbanking/requisition', 'accounting/openbanking/requisitions')
    , new EntityResourceUrls('AccountingOpenBankingAccount', 'accounting/openbanking/account', 'accounting/openbanking/accounts')
    , new EntityResourceUrls('AccountingOpenBankingTransaction', 'accounting/openbanking/transaction', 'accounting/openbanking/transactions')
    // TimeLog
    , new EntityResourceUrls('TimeLog', 'time-management /time-log', 'time-management/time-logs')
];

